module.exports = __webpack_public_path__ + "img/fashion_44.370d0f93.jpg";